import React, { useCallback, useMemo } from "react";
import styled from "styled-components";

import { SelectInput, SelectInputProps, tSelectValue } from "--floponents-web/atoms/SelectInput";

const DeviceSelectInput = styled(SelectInput)`
    flex: 1;
    min-width: 0;
`;

export const DeviceSelectContainer = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing(1)};
    align-items: end;
`;


export interface DeviceSelectProps extends Omit<
    SelectInputProps<unknown>,
    "options" | "value" | "onChange"
> {
    devices?: Array<MediaDeviceInfo>;
    deviceId: string;
    onChange: (deviceId: string) => void;
}
export const DeviceSelect = (props: DeviceSelectProps) => {
    const { devices, deviceId, onChange, ...selectProps } = props;

    const options: Array<tSelectValue<string>> = useMemo(() => {
        if (!devices) return [];
        return devices?.map((device, idx) => ({
            key: device.deviceId,
            value: device.label ?? `Device ${idx + 1}`
        }));
    }, [devices]);

    const value = useMemo(() => (
        options.find(option => option.key === deviceId)
    ), [options, deviceId]);

    const handleChange = useCallback((val: tSelectValue<string>) => {
        onChange(val.key);
    }, [onChange]);

    return (
        <DeviceSelectInput
            options={options}
            value={value}
            onChange={handleChange}
            size="small"
            {...selectProps}
        />
    );
};
